// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import VueClipboard from 'vue-clipboard2';
import "babel-polyfill"
import * as FullStory from '@fullstory/browser';

Vue.use(VueClipboard);

Vue.config.productionTip = false;

Vue.config.ignoredElements = [
    'md-checkbox',
];

FullStory.init({ orgId: process.env.FULL_STORY_ORG_ID || 'A6GD9' });
Vue.prototype.$FullStory = FullStory;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    store: store,
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js